<markant-callout class="bottom callout-p0-16" colorScheme="" [ngClass]="type">
  <div slot="header" *ngIf="header">{{ header }}</div>
  <div slot="content" style="width: 100%">
    <div class="flex-spaced-between">
      <markant-icon *ngIf="icon" [icon]="icon"></markant-icon>

      <p class="text" [innerHTML]="message"></p>

      <div class="action-buttons">
        <markant-button
          *ngIf="closeable"
          colorScheme="primary"
          variant="clear"
          (click)="closed.emit()"
        >
          {{ 'common.close' | transloco }}
        </markant-button>
      </div>
    </div>
  </div>
</markant-callout>
